function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-134 -221)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 49.5,
  cy: 49.5,
  r: 49.5,
  transform: "translate(134 221)",
  fill: "#ca8626"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(151 245.757)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M411.368,103.394,412.1,61.3a1.984,1.984,0,0,1,2.026-2.01l7.054.383A2.007,2.007,0,0,1,423,61.829L420.976,103.9a1.974,1.974,0,0,1-2.038,1.942l-5.756-.361a2,2,0,0,1-1.815-2.082",
  transform: "translate(-357.059 -59.291)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M155.236,131.083a4.877,4.877,0,0,0,4.64,6.265c3.353.171,5.455-.931,6.368-3.862,1.26-4.064-.163-6.871-3.406-7.588S156.325,126.685,155.236,131.083ZM173.53,126.3a12.464,12.464,0,0,1,.852,3.463c.64,6.317-2.807,13.073-8.884,14.872-4.882,1.441-12.467-.253-15.78-5.469a15.468,15.468,0,0,1-2.371-9.089c.041-.465.106-.931.193-1.39a14.2,14.2,0,0,1,3.793-7.382,11.469,11.469,0,0,1,7.748-3.309C164.772,117.672,171.184,120.545,173.53,126.3Z",
  transform: "translate(-127.908 -110.209)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.322,133.33.628,91.558a2.037,2.037,0,0,1,1.838-2.213l7.764-.7a2.03,2.03,0,0,1,2.2,1.917l1.838,32.559a2.028,2.028,0,0,0,2.254,1.908l16.26-1.917a2.026,2.026,0,0,1,2.25,1.844l.492,5.566a2.035,2.035,0,0,1-1.835,2.213L6.516,135.18a2.029,2.029,0,0,1-2.194-1.85",
  transform: "translate(-0.62 -84.758)",
  fill: "#fff"
})));

var SvgReactionLol = function SvgReactionLol(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReactionLol, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reaction-lol.f0435c55.svg";
export { ForwardRef as ReactComponent };